import React from "react";

const trainingOptions = [
    {
        id: 1,
        title: "lectures",
        description:
            "Recorded lectures by globally experienced instructors available throughout the entire semester for course students.",
    },
    {
        id: 2,
        title: "Online seminars",
        description:
            "Live Zoom sessions with Norair Babadjanian for in-depth discussions and expert insights.",
    },
    {
        id: 3,
        title: "Live Sessions",
        description:
            "Exclusive interviews with global professionals offering valuable insights and practical expertise.",
    },
];

const Training = () => {
    return (
        <div className="">
            <h2 className="font-semibold text-[24px]">Method of training</h2>
            <div className="flex flex-wrap justify-between gap-5 pt-[30px] pb-[14px] bg-[#0A1F44] text-[#FFF] mt-[24px]">
                {trainingOptions.map((option, index) => (
                    <div
                        key={option.id}
                        className="w-full sm:w-full lg:w-[32%] px-4 sm:border-b-0 pb-3 border-b lg:border-r border-gray-300 last:border-r-0 last:border-b-0"
                    >
                        <h1 className="text-[56px] sm:text-[76px] font-bold">{option.id}</h1>
                        <h2 className="uppercase font-semibold pt-4 text-[20px]">
                            {option.title}
                        </h2>
                        <p className="text-[16px] font-medium opacity-80 pt-3">
                            {option.description}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Training;
